import { render, staticRenderFns } from "./FamilyProfile.vue?vue&type=template&id=19747b24"
import script from "./FamilyProfile.vue?vue&type=script&lang=js"
export * from "./FamilyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports